<template>
  <div class="comp-info-modal">
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="ques-wrap ">
            <p v-bind:tabIndex="(enableTab) ? 1 : -1"
              v-focus="(initFocus && !hasAnswer)"
              @focus="initFocus = true"
              @blur="initFocus = false"
              class="title-style">
              <span>Question:</span> <br>
              {{content.data.title}}
            </p>
          </div>
        </v-flex>

        <v-flex xs12 class="center-content object-list-wrap">
          <div role="button" class="object-wrap"
            v-for="(object, key) in content.data.objects"
            v-bind:key="key"
            v-bind:tabIndex="(enableTab) ? (key + 2) : -1"
            @click="showModal(object.label, object.description)"
            @keyup.enter="showModal(object.label, object.description)"
          >
            <img
              v-bind:src="require('../../assets/' + object.imageName)"
            />
            <p>{{object.label}}</p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <modal-ok
      :allowMinMode="false"
      :message="currentLabel"
      :details="currentDesc"
      :buttonLabel="'Got it'"
      :isShown="hasSelect"
      @onClicked="closeModal"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { focus } from 'vue-focus'
import ModalOk from '../../components/modal-ok/modalOk'

export default {
  name: 'InfoModal',
  directives: {
    focus: focus,
    focusing: {
    // directive definition
      inserted: function (el, bind) {
        alert(bind.value)
        if (bind.value) {
          console.log(el)
          el.focus()
        }
      }
    }
  },
  components: {
    ModalOk
  },
  data () {
    return {
      initFocus: false,
      enableTab: true,
      activeTabIndex: -1,
      hasSelect: false,
      currentLabel: '',
      currentDesc: ''
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: false,
      dafault: false
    }
  },
  computed: {
    content () {
      return this.$store.getters.getData(this.dataId)
    }
  },
  created () {
    this.$eventHub.$on('tab-pressed', () => {
      if (this.isActive) {
        this.activeTabIndex++
      }
      this.resetTabIndex()
    })

    this.$eventHub.$on('shift-tab-pressed', () => {
      if (this.isActive) {
        if (this.activeTabIndex > 0) {
          this.activeTabIndex--
        }
      }
      this.resetTabIndex()
    })
  },
  watch: {
    isActive () {
      if (this.isActive) {
        this.initFocus = true
        this.activeTabIndex = 1
      } else {
        this.activeTabIndex = -1
      }
    }
  },
  methods: {
    ...mapMutations([
      'nextSlide'
    ]),
    showModal (label, description) {
      this.hasSelect = true
      this.currentLabel = label
      this.currentDesc = description
    },
    deselectChoices (obj) {
      let responseList = this.content.data.responses
      for (let index = 0; index < responseList.length; index++) {
        console.log(obj)
        const element = responseList[index]

        element.isSelected = false
      }
    },
    closeModal () {
      this.hasSelect = false
    },
    resetTabIndex () {
      if (document.hasFocus()) {
        if (document.activeElement.getAttribute('islast') === 'true') {
          this.activeTabIndex = 1
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/info-modal/InfoModal.vue